// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\" data-cy=\"transactionDetail-itemType\" ng-bind=\"grid.appScope.TransactionDetail.getItemTypeName(row.entity)\"></div>\n</div>\n";
// Exports
module.exports = code;